/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAdminSlice } from '../slice';
import { selectIsUserSessionsLoading, selectUserSessions } from '../slice/selectors';
import { selectCurrentProduct } from '../../MainLayout/slice/selectors';

export default function useUserSessions(userId: string | null) {
  const dispatch = useDispatch();
  const { actions } = useAdminSlice();
  const userSessions = useSelector(selectUserSessions);
  const isLoading = useSelector(selectIsUserSessionsLoading);
  const currentProduct = useSelector(selectCurrentProduct);
  useEffect(() => {
    if (!userId) {
      dispatch(actions.clearUserSessions());
      return;
    }

    dispatch(actions.getUserSessions({productId: currentProduct as string, userId: userId }));
  }, [actions, dispatch, userId]);

  return { isLoading, userSessions };
}
